// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { MessageBox,Notification, Message} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import store from './store/index'
import VueAxios from 'vue-axios'
import vueCookies from 'vue-cookies'
import './assets/iconfont.css'
import BaiduMap from 'vue-baidu-map'
import { mapActions } from 'vuex'
//import echarts from 'echarts'
import * as echarts from 'echarts';
import {changeflagCLOSED1234,Loadingdata} from "@/utils/request";
import 'default-passive-events'
// 多语言
import VueI18n from 'vue-i18n'
import cn from './language/cn'
import en from './language/en'
Vue.use(VueI18n)
// 语言信息
const messages = {
  cn: cn,
  en: en
}
const i18n = new VueI18n({
  locale: 'cn', // 语言标识
  messages
})
Vue.prototype.$echarts = echarts

Vue.use(BaiduMap, {
  ak: 'iOTOtBc29bzLdQ46lCk5VYheFVyK89r1'
});

Vue.use(vueCookies)

// 解决跨域session问题
axios.defaults.withCredentials = true

Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.noRequireAuth)) { // 判断该路由是否需要登录权限
    if (store.state.uid) { // 判断当前的token是否存在 ； 登录存入的token
      next();
    }
    else {
      if (sessionStorage.getItem('store')) {
        store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))));
      }
      if (store.state.uid) {
        next();
      }
      else {
        next({
          path: '/login',
          //  query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    }
  }
  else {
    if (!store.state.DMFSession && sessionStorage.getItem('store')) {
      store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))));
    }
    next();
  }
});

axios.interceptors.request.use(
  config => {
    // changeflag()
    //比如是否需要设置 token
    // console.log("axios.interceptors.request.use" + store.state.DMFSession)
    config.headers['DMFSession'] = store.state.DMFSession;
    // config.headers.token = 'wwwwwsdsdf'
    return config
  }
);

axios.interceptors.response.use(

  response => {
    // console.log(response);
    if(response.headers['dmfsession'])
      store.commit('setDMFSession', response.headers['dmfsession']);

    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      // if(response.data.Code!=='MSGKEY_OK'){
      //   // Notification({
      //   //   title: 'error',
      //   //   message: response.data.Message+'<br>'+response.data.MessageEng,
      //   //   dangerouslyUseHTMLString:true,
      //   //   customClass:'zlevelmost',
      //   //   type: 'error'
      //   // })
      // };
      return Promise.resolve(response);
    } else {
      // Notification({
      //   title: 'error',
      //   message: response.data.Message+'<br>'+response.data.MessageEng,
      //   customClass:'zlevelmost',
      //   type: 'error'
      // })
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    console.log("interceptors.error");
    console.log(error);
    changeflagCLOSED1234()
    let loading=Loadingdata().service({ fullscreen: true })
    // Notification({
    //   title: 'error',
    //   message: 'Request failed with status code 500',
    //   dangerouslyUseHTMLString:true,
    //   customClass:'zlevelmost',
    //   type: 'error'
    // })
    loading.close()
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          MessageBox.alert("登录信息超时，请重新登录！", "登录超时", {
            confirmButtonText: "跳转至登录页面",
            callback: action => {
              window.location.href = "/login";
            }
          })

          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          MessageBox.alert("登录信息超时，请重新登录！", "登录超时", {
            confirmButtonText: "跳转至登录页面",
            callback: action => {
              window.location.href = "/login";
            }
          })
          // 清除token
          break;

        // 404请求不存在
        case 404:
          console.log("您访问的网页不存在。");
          break;
        // 其他错误，直接抛出错误提示
        case 500:
          Notification({
            title: 'error',
            message: 'Request failed with status code 500',
            dangerouslyUseHTMLString:true,
            customClass:'zlevelmost',
            type: 'error'
          })
          break;
        default:
          console.log(error.response.data.message);
          Notification({
            title: 'error',
            message: error.response.data.message,
            dangerouslyUseHTMLString:true,
            customClass:'zlevelmost',
            type: 'error'
          })
      }
      return Promise.reject(error.response);
    }
  }
);

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js